
import { Facet } from '../Facet';

export class LayoutTypeFacet extends Facet<{}> {
  public readonly name: string;

  constructor(name: string) {
    super(name);

    this.name = name;
  }
}
